<template>
    <v-container class="pa-0 my-2">
        <ul>
            <li v-for="(value, index) in values" :key="index" :class="index < values.length - 1 ? 'mr-4' : ''">
                <v-icon :color="value.color">
                    {{ value.icon }}
                </v-icon>
                <small>
                    {{ $t(`supplier.${value.status}`) }}
                </small>
            </li>
        </ul>
    </v-container>
</template>

<script lang="ts">
    import {Component, Vue, Prop} from 'vue-facing-decorator'

    @Component({})
    export class CalendarLegend extends Vue {
        @Prop({required: true}) contract

        values = [
            {status: 'bookable', icon: 'mdi-checkbox-blank-circle', color: 'green'},
            {status: 'has_restrictions', icon: 'mdi-bell-circle', color: 'green'},
            {status: 'closed', icon: 'mdi-checkbox-blank-circle', color: 'red'},
            {status: 'sold_out', icon: 'mdi-checkbox-blank-circle', color: 'yellow'},
            {status: this.isOwnHotel ? 'no_room' : 'no_service', icon: 'mdi-checkbox-blank-circle', color: 'grey'},
        ]

        get isOwnHotel() {
            return this.contract?.serviceType === 'ownHotel'
        }
    }

    export default CalendarLegend
</script>

<style scoped lang="scss">
    ul {
        list-style: none;
        padding: 0;
        display: flex;
        justify-content: flex-end;
    }
</style>
